import type { ContentBuilder } from '../../ui/ContentBuilder';
import type { SettlementView } from '../utils';
import { getWildlifeAgeBars, getWildlifeTotal } from '../utils';
import type { HexMapState } from '../../../engine/render/renderer';
import { t } from '../../../i18n/translations';

export function renderWildlifeTab(
    builder: ContentBuilder,
    state: HexMapState,
    settlement: SettlementView,
): void {
    const lang = state.config.ui.language;
    builder.section(t(lang, 'wildlife.section'), (section) => {
        section.text(t(lang, 'wildlife.total', getWildlifeTotal(settlement)));
    });
    builder.section(t(lang, 'wildlife.byAge'), (section) => {
        const bars = getWildlifeAgeBars(state, settlement);
        if (bars.length === 0) {
            section.text(t(lang, 'wildlife.none'));
            return;
        }
        bars.forEach((bar) => section.bar(bar.label, bar.value, bar.max, bar.tone));
    });
}
